import { z } from "zod";

export const avatarSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
});

export type AvatarSchema = z.infer<typeof avatarSchema>;
